import HookForm from '../../../../components/HookForm/HookForm';
import Select from '../../../../components/Select/Select';
import { DEAL_STATUS_WAITING_FOR_FREEDOM, DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS } from '../../../../constants';

const FreedomCarRegistration = ({ onSubmit, loading }) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <HookForm
        title={'Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¢Ð¡'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
            name: 'status',
            component: Select,
            options: [
              {
                value: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
                label: 'ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¢Ð¡ Ð½Ð° ÑÑÐµÑ',
              },
              {
                value: DEAL_STATUS_WAITING_FOR_FREEDOM,
                label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð° Ð½Ð° ÑÑÐµÑ',
              },
            ],
            required: true,
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
      />
    </div>
  );
};

export default FreedomCarRegistration;
